import gql from 'graphql-tag';
import HeaderItemFragment from './fragments/HeaderItem.gql';
import LinkItemFragment from './fragments/LinkItem.gql';
import MetadataItemFragment from './fragments/MetadataItem.gql';
import BaseContentBundleFragment from './fragments/BaseContentBundle';
import StandaloneContentBundleFragment from './fragments/StandaloneContentBundle';

export default gql`
  query page(
    $site: String!
    $path: String!
    $preview: String
    $wptest: String
    $cursor: String
    $limit: Int
  ) {
    page(
      input: {
        site: $site
        path: $path
        preview: $preview
        wptest: $wptest
        cursor: $cursor
        limit: $limit
      }
    ) {
      pageBundles {
        id
        layout
        items {
          ...HeaderItemFragment
          ...LinkItemFragment
          ...MetadataItemFragment
        }
      }
      contentBundles {
        data {
          ...BaseContentBundleFragment
          ...StandaloneContentBundleFragment
        }
        pageInfo {
          nextCursor
        }
      }
    }
  }
  ${HeaderItemFragment}
  ${LinkItemFragment}
  ${MetadataItemFragment}
  ${BaseContentBundleFragment}
  ${StandaloneContentBundleFragment}
`;
